import {
  CampaignMessageKind,
  CampaignMessageSide,
  CampaignMessageView,
} from '@interfaces';
import styled, { css } from 'styled-components';

interface BubbleProps {
  side?: CampaignMessageSide;
  kind?: CampaignMessageKind;
  view?: CampaignMessageView;
  backgroundColor?: string;
  CTAStyle?: string;
  first?: boolean;
  last?: boolean;
  isV2Theme?: boolean;
  textColor?: string;
}

const Bubble = styled.div<BubbleProps>`
  display: inline-block;
  padding: 16px;
  
  background-color: ${({ CTAStyle, backgroundColor }) =>
    CTAStyle === 'solid' || !CTAStyle ? backgroundColor : 'transparent'};

  border: 2px solid ${({ backgroundColor }) => backgroundColor};

  overflow: hidden;
  box-sizing: border-box;

  transition: filter 0.6s ease-in-out, background-color 0.3s ease-in-out;

  ${({ CTAStyle, backgroundColor }) => CTAStyle === 'outline' && css`
    p {
      color: ${backgroundColor};
      transition: color 0.3s ease-in-out;
    }
    `}

  &:hover {
    filter: brightness(0.88);
    
    ${({ CTAStyle, backgroundColor, textColor }) => CTAStyle === 'outline' && css`
    background-color: ${backgroundColor};
    p {
      color: ${textColor};
    }
    `}
  }
  
  ${({ isV2Theme, CTAStyle, backgroundColor }) => isV2Theme && css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    border: ${CTAStyle === 'solid' ? 'none' : `1px solid ${backgroundColor}`};
  `}


  ${({ side, first, last = true }) =>
    side === 'left' &&
    css`
      border-top-right-radius: 24px;
      border-bottom-right-radius: 24px;
      border-top-left-radius: ${first ? '24px' : '0px'};
      border-bottom-left-radius: ${last ? '24px' : '0px'};
      transform-origin: ${first ? 'bottom left' : 'top left'};
    `}

  ${({ side }) =>
    side === 'right' &&
    css`
      align-self: flex-end;
      margin-left: 0px;
      border-radius: 24px;
      border-bottom-right-radius: 0px;
      transform-origin: bottom right;
    `}

  ${({ kind, view }) =>
    (kind === 'button' || kind === 'link') &&
    css`
      width: 100%;
      border-radius: ${view === 'square' ? '4px' : '28px'};
      transform-origin: center;
      cursor: pointer;
    `}

  ${({ kind }) =>
    kind === 'asset' &&
    css`
      padding: 0px;
      background: none;
    `}
`;

export default Bubble;
